/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FusionMelcoModelsSelectListItem,
    FusionMelcoModelsSelectListItemFromJSON,
    FusionMelcoModelsSelectListItemFromJSONTyped,
    FusionMelcoModelsSelectListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface FusionMelcoModelsDefaultAppSetting
 */
export interface FusionMelcoModelsDefaultAppSetting {
    /**
     * 
     * @type {Array<FusionMelcoModelsSelectListItem>}
     * @memberof FusionMelcoModelsDefaultAppSetting
     */
    measurements?: Array<FusionMelcoModelsSelectListItem> | null;
    /**
     * 
     * @type {Array<FusionMelcoModelsSelectListItem>}
     * @memberof FusionMelcoModelsDefaultAppSetting
     */
    emb_formats?: Array<FusionMelcoModelsSelectListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsDefaultAppSetting
     */
    max_canvas_size?: number;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsDefaultAppSetting
     */
    min_image_size?: number;
}

export function FusionMelcoModelsDefaultAppSettingFromJSON(json: any): FusionMelcoModelsDefaultAppSetting {
    return FusionMelcoModelsDefaultAppSettingFromJSONTyped(json, false);
}

export function FusionMelcoModelsDefaultAppSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoModelsDefaultAppSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'measurements': !exists(json, 'measurements') ? undefined : (json['measurements'] === null ? null : (json['measurements'] as Array<any>).map(FusionMelcoModelsSelectListItemFromJSON)),
        'emb_formats': !exists(json, 'emb_formats') ? undefined : (json['emb_formats'] === null ? null : (json['emb_formats'] as Array<any>).map(FusionMelcoModelsSelectListItemFromJSON)),
        'max_canvas_size': !exists(json, 'max_canvas_size') ? undefined : json['max_canvas_size'],
        'min_image_size': !exists(json, 'min_image_size') ? undefined : json['min_image_size'],
    };
}

export function FusionMelcoModelsDefaultAppSettingToJSON(value?: FusionMelcoModelsDefaultAppSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'measurements': value.measurements === undefined ? undefined : (value.measurements === null ? null : (value.measurements as Array<any>).map(FusionMelcoModelsSelectListItemToJSON)),
        'emb_formats': value.emb_formats === undefined ? undefined : (value.emb_formats === null ? null : (value.emb_formats as Array<any>).map(FusionMelcoModelsSelectListItemToJSON)),
        'max_canvas_size': value.max_canvas_size,
        'min_image_size': value.min_image_size,
    };
}


